import { createAction } from 'typesafe-actions';

export const youtubeQuotaLimitDialogShow = createAction(
  'youtube/dialogs/limit/SHOW',
)();

export const youtubeQuotaLimitDialogClose = createAction(
  'youtube/dialogs/limit/CLOSE',
)();
